import { createRoot } from 'react-dom/client';
import App from 'App';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { theme } from 'theme';
import 'index.css';
import { DYNATRACE_RUM_SRC } from 'services/const';

if(DYNATRACE_RUM_SRC) {
  const script = document.createElement('script');
  script.src = DYNATRACE_RUM_SRC;
  script.async = true;
  script.crossOrigin = 'anonymous';
  script.type = 'text/javascript';
  document.head.appendChild(script);
}


const root = createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <App />
  </ThemeProvider>
);
